import React, { useState, useRef } from "react"
import PropTypes from "prop-types"
import { Button, Flex } from "antd"
import { Modal } from "ui/Modal"
import { useTranslation } from "react-i18next"
import { Title } from "ui/Typography"
import { AiEnhancementForm } from "./Form"
import { ConfirmModal } from "ui/ConfirmModal"

export const AiEnhancementModal = ({ triggerButton, description, setDescription, setProfileDescription, profileDescription, modalTitle, messages, refinementTooltipTitle, improveWithAITooltipTitle, onOk, onCancel, text, width = 800, style, ...rest }) => {
  const { t } = useTranslation()
  const [isModalOpen, setIsModalOpen] = useState(false)
  const [isConfirmOpened, setIsConfirmOpened] = useState(false)
  const [aiDescriptionData, setAiDescriptionData] = useState(null)
  const [isSaved, setIsSaved] = useState(false)
  const formRef = useRef(null)


  const handleOk = () => {
    if (onOk) {
      setDescription(aiDescriptionData);
      onOk()
    }
    setIsModalOpen(false)
  }

  const handleCancel = () => {
    if (formRef.current?.hasUnsavedChanges?.()) {
      setIsConfirmOpened(true)
    } else {
      onCancel()
    }
  }

  const onConfirm = () => {
    if (onCancel) {
      onCancel()
    }
    setIsModalOpen(false)
    setIsConfirmOpened(false)
  }

  return (
    <>
      <Modal
        centered
        title={<Title level={3}>
          {modalTitle}
        </Title>}
        open={isModalOpen}
        onCancel={handleCancel}
        maskClosable={false}
        footer={
          <Flex wrap gap="small">
            <Button color="primary" variant="outlined" onClick={() => setIsConfirmOpened(true)}>
              {t("global.cancel")}
            </Button>
            <Button color="primary" variant="solid" onClick={handleOk} disabled={isSaved}>
              {t("global.save")}
            </Button>
          </Flex>
        }
        width={width}
        style={style}
        {...rest}
      >
        <AiEnhancementForm
          ref={formRef}
          description={description}
          setDescription={setDescription}
          setProfileDescription={setProfileDescription}
          text={text}
          messages={messages}
          refinementTooltipTitle={refinementTooltipTitle}
          improveWithAITooltipTitle={improveWithAITooltipTitle}
          setAiDescriptionData={setAiDescriptionData}
          setIsSaved={setIsSaved}
        />
      </Modal>
      <ConfirmModal
        title={t("pro.ai_enhancement.close_modal_confirm_title")}
        info={t("pro.ai_enhancement.close_modal_confirm_info")}
        cancelLabel={t("pro.ai_enhancement.close_modal_confirm_cancel")}
        okLabel={t("pro.ai_enhancement.close_modal_confirm_ok")}
        open={isConfirmOpened}
        onCancel={() => setIsConfirmOpened(false)}
        onOk={onConfirm}
        zIndex={1300}
      />
    </>
  )
}

AiEnhancementModal.propTypes = {
  triggerButton: PropTypes.node,
  description: PropTypes.string,
  setDescription: PropTypes.func.isRequired,
  setProfileDescription: PropTypes.func,
  profileDescription: PropTypes.string,
  modalTitle: PropTypes.node,
  messages: PropTypes.array,
  refinementTooltipTitle: PropTypes.node,
  improveWithAITooltipTitle: PropTypes.node,
  onOk: PropTypes.func,
  onCancel: PropTypes.func,
  text: PropTypes.string,
  width: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  style: PropTypes.object,
}
